import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import EnquiryTypeForm from '../../../components/forms/EnquiryTypeForm';
import { useEnquiryTypeApi } from '../../../hooks/useEnquiryTypeApi';
import { useNavigate } from 'react-router-dom';
import { EnquiryTypeDTO } from '../../../services/apiClient';

const EnquiryTypeCreate: React.FC = () => {
  const { create, isLoading } = useEnquiryTypeApi();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Enquiry Types', href: '/admin/enquirytypes' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: EnquiryTypeDTO) => {
    try {
      setIsSubmitting(true);
      await create(data);
      navigate('/admin/enquirytypes');
    } catch (error) {
      console.error('Error creating EnquiryType:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/enquirytypes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.EnquiryType.Edit"
    >
      <EnquiryTypeForm
        initialValues={{} as EnquiryTypeDTO}
        onSubmit={handleSubmit}
        onCancel={() => navigate('/admin/enquirytypes')}
        isLoading={isSubmitting}
      />
    </AdminLayout>
  );
};

export default EnquiryTypeCreate;
